import { Box, Text } from "@chakra-ui/react";
import React from "react";

const TableauNotAvailableThisTime = () => {
  return (
    <Box textAlign="center" color="red" py={5}>
      <Text>Tableau is only available 06:00am - 07:30pm MST Monday-Friday</Text>
    </Box>
  );
};

export default TableauNotAvailableThisTime;
